// extracted by mini-css-extract-plugin
module.exports = {"figcaption":"FigureCaption-module--figcaption--16PeE"};